// frontend/packs/session-auth.js

import SocialSessionButtonsController from 'components/sessions/social-session-buttons/social-session-buttons-controller';
import AccountFormController from 'components/sessions/registration-form/account-form-controller';
import DetailsFormController from 'components/sessions/registration-form/details-form-controller';
import LoginFormController from 'components/sessions/login-form/login-form-controller';
import ResetPasswordFormController from 'components/sessions/reset-password-form/reset-password-form-controller';
import SignupModalController from 'components/sessions/signup-modal-controller';
import GoogleOneTapController from 'components/sessions/google-one-tap/google-one-tap-controller';

window.EezyStimulusApplication.register('social-session-buttons', SocialSessionButtonsController);
window.EezyStimulusApplication.register('registrations-account-form', AccountFormController);
window.EezyStimulusApplication.register('registrations-details-form', DetailsFormController);
window.EezyStimulusApplication.register('login-form', LoginFormController);
window.EezyStimulusApplication.register('reset-password-form', ResetPasswordFormController);
window.EezyStimulusApplication.register('signup-modal', SignupModalController);
window.EezyStimulusApplication.register('google-one-tap', GoogleOneTapController);
